/**
 * @generated SignedSource<<3d1980d036a4488b901bb38f5119bb29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationFlyerScreenDeleteFlyerMutation$variables = {
  id: string;
};
export type IntegrationFlyerScreenDeleteFlyerMutation$data = {
  readonly store: {
    readonly deleteIntegrationFlyer: boolean | null;
  };
};
export type IntegrationFlyerScreenDeleteFlyerMutation = {
  response: IntegrationFlyerScreenDeleteFlyerMutation$data;
  variables: IntegrationFlyerScreenDeleteFlyerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ScalarField",
        "name": "deleteIntegrationFlyer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationFlyerScreenDeleteFlyerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationFlyerScreenDeleteFlyerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df608e9c4236fb85c49372b1d07be46c",
    "id": null,
    "metadata": {},
    "name": "IntegrationFlyerScreenDeleteFlyerMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationFlyerScreenDeleteFlyerMutation(\n  $id: ID!\n) {\n  store {\n    deleteIntegrationFlyer(id: $id)\n  }\n}\n"
  }
};
})();

(node as any).hash = "91757e04f71ac9bebcd55ddf57a5637c";

export default node;
